(function ($) {
  "use strict";

  const CONFIG = {
    minSearchLength: 3,
    debounceDelay: 300,
    maxResults: 10,
    maxPreviewProducts: 4,
    mobileBreakpoint: 1160,
    selectors: {
      searchModal: "#search-modal",
      searchInput: '#search-modal input[type="text"]',
      searchForm: '#search-modal .search-form, #search-modal #search-form',
      utilArea: ".util-area",
      suggestions: ".tm-search-suggestion",
      discover: ".tm-search-discover",
      mobileResults: ".see_all_result_mobile",
      searchIcon: ".search-header-icon",
    },
  };

  class ShopifySearch {
    constructor() {
      this.searchTimeout = null;
      this.currentController = null;
      this.$searchInput = $(CONFIG.selectors.searchInput);
      this.$utilArea = $(CONFIG.selectors.utilArea);
      this.$suggestions = $(CONFIG.selectors.suggestions);
      this.$discover = $(CONFIG.selectors.discover);
      this.$mobileResults = $(CONFIG.selectors.mobileResults);
      this.$searchForm = $(CONFIG.selectors.searchForm);
      this.searchType = this.$searchForm.find('input[name="type"]').val();
      this.$resultsWrapper = $('<div class="search-results-wrapper"></div>')
        .appendTo(this.$utilArea)
        .hide();
      this.$autocompleteBox = $(
        '<div class="autocomplete-box"></div>'
      ).appendTo(this.$resultsWrapper);
      this.$productsBox = $('<div class="products-box"></div>').appendTo(
        this.$resultsWrapper
      );
      this.init();
    }

    init() {
      this.bindEvents();
      this.$mobileResults.hide();
    }

    bindEvents() {
      this.$searchInput
        .on("input", (e) => this.handleInput(e))
        .on("focus", () => this.handleFocus())
        .attr("autocomplete", "off");

      $(CONFIG.selectors.searchForm).on("submit", (e) => this.handleSubmit(e));

      $(document).on("click", (e) => {
        if (!$(e.target).closest(CONFIG.selectors.searchModal).length) {
          this.hideAll();
        }
      });

      // Re-trigger search on mobile when the modal is reopened
      $(document).on("click", 'a[data-modal-toggle="#search-modal"]', () => {
        if ($("body").hasClass("modal-active")) return;
        const isMobile = (typeof theme !== 'undefined' && theme.viewport) ? !theme.viewport.isSm() : ($(window).outerWidth() < 768);
        if (isMobile) {
          setTimeout(() => {
            this.handleFocus();
          }, 100);
        }
      });
    }

    // ✅ NEW: Sanitize search term by removing special characters
    sanitizeSearchTerm(term) {
      // Allow: letters, numbers, spaces, hyphens, and apostrophes
      // Remove all other special characters
      return term.replace(/[^a-zA-Z0-9\s\-']/g, '').trim();
    }

    // ✅ FIX: Re-trigger search when input is focused with an existing value
    // (e.g. user closes and reopens the search modal)
    handleFocus() {
      let term = this.$searchInput.val().trim();
      term = this.sanitizeSearchTerm(term);

      if (!term) return;

      this.hideSuggestions();
      this.hideDiscover();
      this.$resultsWrapper.show();
      this.fetchResults(term);
    }

    handleInput(e) {
      let term = this.$searchInput.val().trim();

      // ✅ Sanitize the search term
      term = this.sanitizeSearchTerm(term);

      clearTimeout(this.searchTimeout);

      if (this.currentController) {
        this.currentController.abort();
        this.currentController = null;
      }

      if (!term) {
        this.reset();
        return;
      }

      this.hideSuggestions();
      this.hideDiscover();
      this.$resultsWrapper.show();

      this.searchTimeout = setTimeout(() => {
        this.fetchResults(term);
      }, CONFIG.debounceDelay);
    }

    async fetchResults(term) {
      this.currentController = new AbortController();

      const url =
        `/search/suggest.json?q=${encodeURIComponent(term)}` +
        `&resources[type]=query,product,page,article` +
        `&resources[options][fields]=title,product_type,variants.title` +
        `&limit=${CONFIG.maxResults}`;

      try {
        const response = await fetch(url, {
          signal: this.currentController.signal,
        });

        const data = await response.json();
        this.renderResults(data, term);
      } catch (e) {
        if (e.name !== "AbortError") {
          console.error(e);
        }
      }
    }

    renderResults(data, term) {
      const results = data.resources?.results || {};
      const queries = results.queries || [];
      const products = results.products || [];

      this.renderAutocomplete(queries, term);

      if (term.length < CONFIG.minSearchLength) {
        this.$productsBox.empty();
        return;
      }

      this.renderProducts(products, term, products.length);
    }

    renderAutocomplete(queries, term) {
      if (!queries.length) {
        this.$autocompleteBox.empty();
        return;
      }

      const $list = $('<div class="autocomplete-list"></div>');

      // Filter out suggestions with incomplete trailing words (e.g. "Cleo E").
      // A suggestion is considered incomplete if any of its words is a single character.
      const completeQueries = queries.filter((q) => {
        const words = q.text.trim().split(/\s+/);
        return words.every((word) => word.length >= 2);
      });

      if (!completeQueries.length) {
        this.$autocompleteBox.empty();
        return;
      }

      completeQueries.forEach((q) => {
        const text = q.text;

        const $item = $(`
          <div class="autocomplete-item" tabindex="0">
            <span class="autocomplete-text">
              ${this.highlight(text, term)}
            </span>
          </div>
        `);

        $item.on("click", () => {
          window.location.href = `/search?type=${encodeURIComponent(this.searchType)}&options[prefix]=last&q=${encodeURIComponent(
            text
          )}`;
        });

        $list.append($item);
      });

      this.$autocompleteBox.html($list);
    }

    renderProducts(products, term, totalCount) {
      this.$productsBox.empty();

      if (!products.length) return;

      const previewProducts = products.slice(0, CONFIG.maxPreviewProducts);

      const $section = $(
        '<div class="results-section products-section"></div>'
      );

      // ✅ Product count heading
      $section.append(`
        <h3 class="results-section-title">
          Products (${totalCount})
        </h3>
      `);

      // ✅ View all button (only if more than preview count)
      if (totalCount > CONFIG.maxPreviewProducts) {
        const $viewAll = $(`
          <div class="see-all-results">
            <button type="button" class="see-all-btn">
              View All
            </button>
          </div>
        `);

        $viewAll.find(".see-all-btn").on("click", () => {
          window.location.href = `/search?type=${encodeURIComponent(this.searchType)}&options[prefix]=last&q=${encodeURIComponent(
            term
          )}`;
        });

        $section.append($viewAll);
      }

      const $grid = $('<div class="products-grid"></div>');

      previewProducts.forEach((product) => {
        const price = product.price
          ? Shopify.formatMoney(product.price).replace(".00", "")
          : "";

        const $item = $(`
          <a href="${product.url}" class="product-item" tabindex="0">
            <img class="product-image" src=${product.image} />
            <div class="product-wrapper">
              <div class="product-title">
                ${this.highlight(product.title, term)}
              </div>
              <div class="product-price">${price}</div>
            </div>
          </a>
        `);

        $grid.append($item);
      });

      $section.append($grid);

      this.$productsBox.append($section);
    }

    handleSubmit(e) {
      e.preventDefault();
      let term = this.$searchInput.val().trim();

      // ✅ Sanitize the search term
      term = this.sanitizeSearchTerm(term);

      if (!term) return;

      window.location.href = `/search?type=${encodeURIComponent(this.searchType)}&options[prefix]=last&q=${encodeURIComponent(
        term
      )}`;
    }

    hideSuggestions() {
      this.$suggestions.hide();
    }

    hideDiscover() {
      this.$discover.hide();
    }

    reset() {
      this.$autocompleteBox.empty();
      this.$productsBox.empty();
      this.$resultsWrapper.hide();
      this.$suggestions.show();
      this.$discover.show();
    }

    hideAll() {
      this.$resultsWrapper.hide();
    }

    highlight(text, term) {
      const regex = new RegExp(`(${term})`, "gi");
      return text.replace(regex, "<strong>$1</strong>");
    }
  }

  $(document).ready(() => {
    new ShopifySearch();
  });
})(jQuery);